/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { CloudProvider } from '@shared/types/nebula';

export const cloudProviderNames = [
  { value: CloudProvider.AWS, label: 'Amazon Web Services' },
  { value: CloudProvider.GCE, label: 'Google Cloud' },
  { value: CloudProvider.AZURE, label: 'Microsoft Azure' },
] as const;

export enum Dialog {
  ADD_CLUSTER_USER_ID = 'DIALOG_ADD_CLUSTER_USER',
  ATTACH_CLUSTER_ID = 'DIALOG_ATTACH_CLUSTER_ID',
  CHANGE_CLUSTER_USER_PASSWORD_ID = 'DIALOG_CHANGE_CLUSTER_USER_PASSWORD',
  DESTROY_NEBULA_CLUSTER_ID = 'DIALOG_DESTROY_NEBULA_CLUSTER',
  EDIT_ACCESS_LIST_ID = 'DIALOG_EDIT_ACCESS_LIST',
  MANAGE_CLUSTER_USERS_ID = 'DIALOG_MANAGE_CLUSTER_USERS',
  NEBULA_PROVISION_RESULT_ID = 'DIALOG_NEBULA_PROVISION_RESULT',
  PROVISION_CLUSTER_ID = 'DIALOG_PROVISION_CLUSTER_ID',
  RENAME_CLUSTER_ID = 'DIALOG_RENAME_CLUSTER_ID',
}
